module.exports = __webpack_public_path__ + "img/83ne.47b4c42f.svg";